import { useContext } from 'react'

import { EmailProfileActionsContext } from '../../Email.contexts'

export function useEmailProfileActionsContext() {
  return useContext(EmailProfileActionsContext)
}
